<template>
   <el-config-provider :locale="locale"><router-view/></el-config-provider>
</template>
<script setup>

 import {computed, watch} from 'vue'

 import zhCn from 'element-plus/es/locale/lang/zh-cn'
 import en from 'element-plus/es/locale/lang/en'
 import { useStorage } from "@vueuse/core";
 
 
 const language = useStorage("language", "zhCN");

 //每隔5s执行一次 切换一次语言
//  setInterval(() => {
//    console.log("5s执行一次");
//    language.value = language.value === "zhCN" ? "en" : "zhCN";
//  }, 5000);


 watch(language, (newValue, oldValue) => {
   console.log(newValue, oldValue);
 });

 const locale = computed(() => (language.value === "zhCN" ? zhCn : en));

</script>

<style>
 
</style>
